import React from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import useConvertTiffToPng from '@/utils/hooks/useConvertTiffToPng';

import { ImgSquare } from '../ScanPreview.styles';

interface Props {
  url?: string;
  alt?: string;
  testId?: string;
}

const TiffThumb: React.FC<Props> = ({ url, alt, testId = '' }) => {
  const { pngDocuments, isLoading } = useConvertTiffToPng({ url });
  const firstImage = pngDocuments?.[0];

  if (isLoading) {
    return (
      <Box data-testId={`${testId}_loading`} height="60px" justify="center" align="center">
        <Preloader testId="tiff-thumb-preloader" />
      </Box>
    );
  }

  return <ImgSquare data-testId={testId} src={firstImage?.link} alt={alt} />;
};

export default TiffThumb;
